import React from 'react';
import NavBar from './../components/NavBar';
import Home from '../components/Home';
import Footer from '../components/Footer';

const Main = () => {
    return (
        <div className=''>
       
            <NavBar ></NavBar>
        
            <Home ></Home>
            <Footer></Footer>
        </div>
    );
};

export default Main;